(ns app.front.view.admin.migration.change-licence-number
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/change-licence-number
    :args      [{:id    :migration-workspace
                 :label "Workspace that has the license"
                 :class "w-full"}
                {:id    :old-municipal-case-id
                 :label "Current :workspace/municipal-case-id"}
                {:id    :new-municipal-case-id
                 :label "New municipal-case-id"}
                {:id    :old-licence-number
                 :label "Current :licence/id"}
                {:id    :new-licence-number
                 :label "New license number"}
                {:id    :old-global-licence-number
                 :label "Current :licence/global-id"}
                {:id    :old-municipal-permit-number
                 :label "Current :verdict/municipal-permit-number"}
                {:id    :new-municipal-permit-number
                 :label "New municipal permit number"}]
    :title     "Change license number for already issued licences"
    :help-text "This tool allows you to change license number for a license which was already been issued. Notice the following:
                - The license numbering must be set to \"Custom license number\".
                - Make sure the new license number is smaller than the next license number under the configurations. If needed, change the \"Next sequential number\" -counter.
                - License is re-issued
                - Notice that all given values are case-sensitive!
                After this migration is done, you need to re-issue the license to make the number right on license document. "}
   match])

(def route
  {:name        :view/admin.migration.change-licence-number
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/change-licence-number]))}]})
